/**
 * Display helpers for the puja storefront. Pure formatting — all puja data
 * comes from `api.puja.*` (packages/api/src/endpoints/puja.ts, contract in
 * PUJA_API_EXAMPLES.md).
 */

export const formatRupees = (n) => `₹${Math.round(Number(n) || 0).toLocaleString('en-IN')}`

/** schedule_type → shopper-facing label (festival_name wins when present). */
const SCHEDULE_LABELS = {
  one_time: 'One-Time Vidhi',
  daily: 'Daily Seva',
  weekly: 'Weekly Seva',
  monthly: 'Monthly Seva',
  yearly: 'Yearly Vidhan',
  festival: 'Festival Special',
}

export const scheduleLabel = (p) =>
  p?.festival_name || SCHEDULE_LABELS[p?.schedule_type] || 'Vedic Ritual'

/** "2026-08-04" → { weekday, label, daysLeft } — nulls for missing/bad input. */
export const pujaDateInfo = (ymd) => {
  if (!ymd) return { weekday: '', label: '', daysLeft: null }
  const date = new Date(`${ymd}T00:00:00`)
  if (Number.isNaN(date.getTime())) return { weekday: '', label: '', daysLeft: null }
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return {
    weekday: date.toLocaleDateString('en-IN', { weekday: 'long' }),
    label: date.toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' }),
    daysLeft: Math.round((date - today) / 86400000),
  }
}

/** "07:00:00" → "7:00 AM" (falls through for empty/odd values). */
export const formatTime = (hms) => {
  if (!hms) return ''
  const [h, m] = hms.split(':').map(Number)
  if (Number.isNaN(h) || Number.isNaN(m)) return hms
  const ampm = h >= 12 ? 'PM' : 'AM'
  const hour = h % 12 || 12
  return `${hour}:${String(m).padStart(2, '0')} ${ampm}`
}

/** Package feature icons arrive as feather tokens ("feather-video") — map
 * the known ones onto the Font Awesome set the shop already loads. */
const FEATHER_TO_FA = {
  'check-circle': 'fa-circle-check',
  gift: 'fa-gift',
  video: 'fa-video',
  truck: 'fa-truck',
  'file-text': 'fa-file-lines',
  phone: 'fa-phone',
  bell: 'fa-bell',
  home: 'fa-house',
  star: 'fa-star',
  award: 'fa-award',
}
export const featureIcon = (icon) =>
  FEATHER_TO_FA[String(icon || '').replace(/^feather-/, '')] || 'fa-circle-check'

/** Readable message from an ApiRequestError: first Laravel field error when
 * the 422 carries an `errors` map, else the envelope/network message. */
export const apiErrorMessage = (err, fallback = 'Something went wrong — try again.') => {
  const details = err?.details
  if (details && typeof details === 'object') {
    const first = Object.values(details).flat().find((m) => typeof m === 'string')
    if (first) return first
  }
  return err?.message || fallback
}
